import { Container, Typography, Paper, Box, Button, Tabs, Tab } from '@mui/material';
import { useState, useEffect } from 'react';
import { useAuthStore } from '@store/authStore';
import { useNavigate } from 'react-router-dom';
import ShotSummary from '@components/ShotSummary';
import ShotEvaluationForm from '@components/ShotEvaluationForm';
import { UserRole } from '@types/index';

const DashboardPage = () => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    // Redirect based on user role
    console.log('DashboardPage - User role:', user?.role, 'UserRole.COACH:', UserRole.COACH);
    if (user?.role === UserRole.ADMIN || user?.role === UserRole.SUPER_ADMIN || user?.role === UserRole.EVALUATION_ADMIN) {
      navigate('/admin');
    } else if (user?.role === UserRole.CONTEST_ADMIN || user?.role === 'contest_admin') {
      navigate('/admin?view=contest-tasks');
    } else if (user?.role === UserRole.COACH) {
      navigate('/coach');
    } else if (user?.role === UserRole.PLAYER) {
      navigate('/player');
    } else if (user?.role === UserRole.ACADEMY_ADMIN || user?.role === 'academy_admin') {
      navigate('/academy-admin/dashboard');
    } else if (user?.role === UserRole.SPONSOR || user?.role === 'sponsor') {
      navigate('/sponsor/dashboard');
    }
  }, [user, navigate]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  // Don't render if user will be redirected to a role-specific dashboard
  if (user?.role === UserRole.ADMIN || user?.role === UserRole.SUPER_ADMIN || user?.role === UserRole.EVALUATION_ADMIN || user?.role === UserRole.CONTEST_ADMIN || user?.role === 'contest_admin' || user?.role === UserRole.COACH || user?.role === UserRole.PLAYER || user?.role === UserRole.ACADEMY_ADMIN || user?.role === 'academy_admin' || user?.role === UserRole.SPONSOR || user?.role === 'sponsor') {
    return null;
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ marginTop: 4, marginBottom: 4 }}>
        <Paper elevation={3} sx={{ padding: 4 }}>
          <Typography variant="h4" gutterBottom>
            Dashboard
          </Typography>
          <Typography variant="body1" gutterBottom>
            Welcome, {user?.email}!
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Role: {user?.role}
          </Typography>

          <Box sx={{ mt: 4 }}>
            <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 3 }}>
              <Tab label="Shot Performance" />
              <Tab label="Record Practice" />
              <Tab label="Coming Soon" />
            </Tabs>

            {activeTab === 0 && (
              <Box>
                <ShotSummary playerId={user?.id || ''} />
              </Box>
            )}

            {activeTab === 1 && (
              <Box>
                <Typography variant="h6" gutterBottom>
                  Record Shot Practice Session
                </Typography>
                <ShotEvaluationForm 
                  playerId={user?.id || ''} 
                  onSuccess={() => {
                    // Refresh shot summary if on that tab
                    if (activeTab === 0) {
                      window.location.reload();
                    }
                  }}
                />
              </Box>
            )}

            {activeTab === 2 && (
              <Box>
                <Typography variant="h6" gutterBottom>
                  Additional features coming soon:
                </Typography>
                <ul>
                  <li>Rally tracking and analysis</li>
                  <li>Tournament registrations</li>
                  <li>Rankings and leaderboards</li>
                  <li>Video uploads and reviews</li>
                  <li>Coach-player interactions</li>
                  <li>Heatmap visualization</li>
                  <li>Performance comparisons</li>
                </ul>
              </Box>
            )}
          </Box>

          <Button variant="contained" color="secondary" onClick={handleLogout} sx={{ mt: 3 }}>
            Logout
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default DashboardPage;


